import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  toggleChat: {
    position: "fixed !important",
    bottom: "10px",
    right: "10px",
  },
});

export default useStyles;